import { styled } from '@mui/material';
import CTAButton from '@components/CTAButton';

export const Wrapper = styled('div')(
  {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '30px 30px 18px',
    borderRadius: 4,
    width: 575,
  },
  ({ theme }) => ({
    backgroundColor: theme.palette.novotalk.$backgroundColor,
  }),
);

export const Title = styled('div')({
  marginBottom: 10,
  textAlign: 'center',
});

export const Body = styled('div')({
  minWidth: 360,
  maxWidth: 360,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  marginBottom: 18,
});

export const Buttons = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 12,
});

export const OptionButton = styled(CTAButton)({
  width: 320,
  height: 52,
  borderRadius: 26,
});

export const CancelButton = styled(CTAButton)({
  width: 320,
  height: 52,
  borderRadius: 26,
});
